/**
 * Plain-text helpers for the one-line contexts: a head sentence, a list row,
 * a card caption. None of them know markdown; strip it first
 * (`stripMarkdownInline`) when the source is a rendered turn.
 */

/**
 * Keep at most `max` characters of `text`, cut at a word boundary, and append
 * a plain three-dot marker (so the return value can run to `max + 3`). The
 * cut only steps back to a space when doing so keeps at least half the
 * ceiling; otherwise the ceiling wins, so one long token cannot shrink the
 * line to nothing. Text that fits comes back untouched, with no marker.
 */
export function clampToWord(text: string, max: number): string {
  if (text.length <= max) return text;
  const cut = text.slice(0, max);
  const atWord = cut.lastIndexOf(" ");
  return `${atWord > max / 2 ? cut.slice(0, atWord) : cut}...`;
}
